import React, { useEffect, useRef } from 'react';

// Same AdSense account + the same three unit IDs the 2016 site ran (pulled from the live DB) —
// "same publisher, redesigned site" signal preserved across the cutover.
export const AD_CLIENT = 'ca-pub-7875719660602728';
export const AD_SLOTS = { rail: '9840921270', footer: '2317654478', inline: '1898852078' };

export default function AdUnit({ slot = 'inline', className = '' }) {
  const ref = useRef(null);
  useEffect(() => {
    try {
      if (ref.current && !ref.current.getAttribute('data-adsbygoogle-status')) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) { /* blocked or not loaded — silent */ }
  }, []);
  return (
    <div className={`my-8 flex justify-center ${className}`} aria-label="Advertisement">
      <ins ref={ref} className="adsbygoogle" style={{ display: 'block', width: '100%', minHeight: 90 }}
        data-ad-client={AD_CLIENT} data-ad-slot={AD_SLOTS[slot] || AD_SLOTS.inline}
        data-ad-format="auto" data-full-width-responsive="true" />
    </div>
  );
}
